import React from "react"
import styled from "styled-components"

const Wrapper = styled.section`
  max-width: 94%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Container = ({ children }) => {
  return <Wrapper> {children} </Wrapper>
}

export default Container
